exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ip-modal .row {\n  max-height: 50vh;\n  overflow-y: scroll;\n}\n.sau-border-bottom {\n  border-bottom: solid 1px #e5e5e5;\n}", ""]);

// exports
